<template>
  <div class="content-box int-rank-box">
    <div class="content-box-title">
      <div>
        <div style="display: flex;align-items: start;">
          <van-image
            :src="require('../../assets/img/title-icon.png')"
            width="18px"
            height="18px"
            class="icon"
          ></van-image>
          学分排名
          <div :class="{ jxsBtn: true, active: currentType == 1 }" @click="getRankList()">
            按PC
          </div>
          <div :class="{ xyBtn: true, active: currentType == 2 }" @click="getUserList()">
            按学员
          </div>
        </div>
      </div>
      <div class="total-rank" @click="goTotal">全部排名 ></div>
    </div>
    <div class="rank-list content-box-container" v-if="currentType == 1">
      <div class="rank-list-box" v-for="(item, i) in rankList" :key="i">
        <div class="rank-list-item">
          <div class="rank-name">
            <div class="rank-icon">
              <span>{{ i + 1 }}</span>
            </div>
            <span>{{ item.dealerName }}</span>
          </div>
          <div class="rank-num">{{ item.integral.toLocaleString('en-US') }}</div>
          <div class="rank-btn" @click="goDetailDealer(item.dealerId,item.integral)" >详情<span> > </span></div>
        </div>
      </div>
    </div>
    <div class="rank-list content-box-container" v-if="currentType == 2">
      <div class="rank-list-box" v-for="(item, i) in userList" :key="i">
        <div class="rank-list-item">
          <div class="rank-name">
            <div class="rank-icon">
              <span>{{ i + 1 }}</span>
            </div>
            <span class="user">{{ item.name }}</span>
            <van-image
              width="52"
              height="16"
              :src="require('../../assets/img/icon-' + item.passportName + '.png')"
            />
            <!-- <div class="rank-badge">
              <div v-for="(e, key) in item.userMapList" :key="key">
                <van-image :src="e.img" width="15" height="13" />
              </div>
            </div> -->
          </div>
          <div class="rank-post">{{ item.postNameView }}</div>
          <div class="rank-num">{{ item.integral.toLocaleString('en-US') }}</div>
          <div class="rank-btn" @click="goDetail(item.ppn)">详情<span> > </span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDealerIntegral, getXyIntegral } from '@/api/common/index.js'
import {Notify} from "vant";
export default {
  name: 'intRank',
  props: {
    dealerId: {
      type: String,
    },
  },
  data() {
    return {
      rankList: [],
      userList: [],
      currentType: 1,
      userType: localStorage.getItem('userType'),
    }
  },
  methods: {
    goTotal() {
      this.$router.push({
        path: '/totalRank',
        query: {
          id: this.userType == '1' ? this.dealerId : null,
        },
      })
    },
    goDetail(id) {
      if (this.currentType == 1) {
        this.$router.push({
          path: '/dealerIndex',
          query: {
            id: id,
          },
        })
      } else if (this.currentType == 2) {
        this.$router.push({
          path: '/userIndex',
          query: {
            id: id,
          },
        })
      }
    },
    goDetailDealer(id, integral) {
      if (this.currentType == 1) {
        if(integral == 0){
          Notify({ type: 'warning', message: '该经销商无售后岗位人员' })
        }else{
          this.$router.push({
            path: '/dealerIndex',
            query: {
              id: id,
            },
          })
        }
      } else if (this.currentType == 2) {
        this.$router.push({
          path: '/userIndex',
          query: {
            id: id,
          },
        })
      }
    },
    getUserList() {
      this.currentType = 2
      getXyIntegral(
        {
          companyId:
            this.userType == '0' ? JSON.parse(localStorage.getItem('user')).companyId : null,
          dealerId: this.userType == '1' ? this.dealerId : null,
        },
        1,
        5
      ).then((res) => {
        this.userList = res.rows
      })
    },
    getRankList() {
      this.currentType = 1
      getDealerIntegral(
        {
          companyId: JSON.parse(localStorage.getItem('user')).companyId,
          dealerId: this.dealerId,
        },
        1,
        5
      ).then((res) => {
        this.rankList = res.rows
      })
    },
  },
  created() {},
  mounted() {
    this.getRankList()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.int-rank-box {
  // background-position: right 6px;
  .content-box-title {
    justify-content: space-between;
    // margin-bottom: 10px;
    .jxsBtn {
      margin-left: 5px;
      width: 65.5px;
      height: 18px;
      line-height: 18px;
      background: url('../../assets/img/jxs.png') center no-repeat;
      background-size: 100%;
      color: #737278;
      font-size: 11px;
      text-align: center;
      &.active {
        background: url('../../assets/img/jxs-active.png') center no-repeat;
        background-size: 100%;
        color: #fff;
      }
    }
    .xyBtn {
      position: relative;
      left: -3px;
      width: 65.6px;
      height: 18px;
      line-height: 18px;
      background: url('../../assets/img/xy.png') center no-repeat;
      background-size: 100%;
      color: #737278;
      font-size: 11px;
      text-align: center;
      &.active {
        background: url('../../assets/img/xy-active.png') center no-repeat;
        background-size: 100%;
        color: #fff;
      }
    }
    .total-rank {
      background-color: #f5f5f5;
      width: 60px;
      height: 20px;
      line-height: 20px;
      text-align: right;
      color: #403f45;
      font-size: 11px;
      font-style: normal;
      font-weight: 400;
    }
  }
}
</style>
